// This file defines the routing of the application.
import React from "react";
import {createBrowserRouter} from "react-router-dom";
import Common from "./Common";
import Home from "./home/Home";
import Products from "./listViews/Products";
import ProductForm from "./forms/formViews/ProductForm";
import ProductGroups from "./listViews/ProductGroups";
import ProductGroupForm from "./forms/formViews/ProductGroupForm";
import Instruments from "./listViews/Instruments";
import InstrumentForm from "./forms/formViews/InstrumentForm";
import ServiceCaseStates from "./listViews/ServiceCase/ServiceCaseStates";
import ServiceCaseStateForm from "./forms/formViews/serviceCase/ServiceCaseStateForm";
import ServiceCases from "./listViews/ServiceCase/ServiceCases";
import ServiceCaseForm from "./forms/formViews/serviceCase/serviceCaseForm/ServiceCaseForm";
import Users from "./listViews/Users";
import UserForm from "./forms/formViews/UserForm";
import ServiceCaseActions from "./listViews/ServiceCase/ServiceCaseActions";
import ServiceCaseActionForm from "./forms/formViews/serviceCase/ServiceCaseActionForm";
import ServiceCaseTypes from "./listViews/ServiceCase/ServiceCaseTypes";
import ServiceCaseTypeForm from "./forms/formViews/serviceCase/ServiceCaseTypeForm";
import ServiceCaseRegimeCosts from "./listViews/ServiceCase/ServiceCaseRegimeCosts";
import ServiceCaseRegimeCostForm from "./forms/formViews/serviceCase/ServiceCaseRegimeCostForm";
import ServiceCaseWorks from "./listViews/ServiceCase/ServiceCaseWorks";
import ServiceCaseWorkForm from "./forms/formViews/serviceCase/ServiceCaseWorkForm";
import ServiceCaseSpareParts from "./listViews/ServiceCase/ServiceCaseSpareParts";
import ServiceCaseSparePartForm from "./forms/formViews/serviceCase/ServiceCaseSparePartForm";
import Companies from "./listViews/Companies";
import CompanyForm from "./forms/formViews/CompanyForm";
import AddressForm from "./forms/formViews/AddressForm";
import ContactForm from "./forms/formViews/ContactForm";
import CompanySetupForm from "./forms/formViews/CompanySetupForm";
import ConfigurationSetupForm from "./forms/formViews/ConfigurationSetupForm";
import Manufacturers from "./listViews/Manufacturers";
import ManufacturerForm from "./forms/formViews/ManufacturerForm";
import LoanTypes from "./listViews/Loan/LoanTypes";
import Loans from "./listViews/Loan/Loans";
import LoanForm from "./forms/formViews/loan/loanForm/LoanForm";
import LoanTypeForm from "./forms/formViews/loan/LoanTypeForm";
import LoanStates from "./listViews/Loan/LoanStates";
import LoanStateForm from "./forms/formViews/loan/LoanStateForm";
import LoanInstrumentHandler from "./forms/formViews/loan/loanForm/LoanInstrumentHandler";
import Installations from "./listViews/Installation/Installations";
import InstallationForm from "./forms/formViews/installation/installationForm/InstallationForm";
import InstallationStates from "./listViews/Installation/InstallationStates";
import InstallationStateForm from "./forms/formViews/installation/InstallationStateForm";
import LoginWrapper from "./login/LoginWrapper";
import VersionInfo from "./VersionInfo";
import BTKStates from "./listViews/BTK/BTKStates";
import BTKs from "./listViews/BTK/BTKs";
import BTKResults from "./listViews/BTK/BTKResults";
import BTKStateForm from "./forms/formViews/btk/BTKStateForm";
import BTKResultForm from "./forms/formViews/btk/BTKResultForm";
import BTKForm from "./forms/formViews/btk/btkForm/BTKForm";
import PricelistLoader from "./dataLoading/PricelistLoader";
import QRScanner from "./dataLoading/QRScanner";
import QRHandler from "./navigation/QRHandler";
import InstrumentsDemo from "./listViews/InstrumentsDemo";
import ServiceCaseStateCategories from "./listViews/ServiceCase/ServiceCaseStateCategories";
import ServiceCaseStateCategoryForm from "./forms/formViews/serviceCase/ServiceCaseStateCategoryForm";
import InstrumentStates from "./listViews/InstrumentStates";
import InstrumentStateForm from "./forms/formViews/InstrumentStateForm";

function tableViewRouter(name, Table, Form) {
    // const TableName = React.createElement(name.charAt(0).toUpperCase() + name.slice(1) + 's')
    // const FormName = React.createElement(name.charAt(0).toUpperCase() + name.slice(1) + 'Form')
    const routed = [
        {
            path: `/${name}s`,
            element: Table
        },
        {
            path: `/${name}s/${name}/new`,
            element: Form
        },
        {
            path: `/${name}s/${name}/:id`,
            element: Form
        },
    ]
    return routed
}

function getRouter() {

    return createBrowserRouter([

        // Main app routing. Each navbar item is different page.
        // create route for each link from Navbar.jsx Navigation() function
        {
            path: "/",
            element: <Common/>,
            children: [
                {
                    path: "/",
                    element: <Home/>
                },
                ...tableViewRouter('product', <Products/>, <ProductForm/>),
                ...tableViewRouter('product_group', <ProductGroups/>, <ProductGroupForm/>),
                ...tableViewRouter('manufacturer', <Manufacturers/>, <ManufacturerForm/>),
                ...tableViewRouter('instrument_state', <InstrumentStates/>, <InstrumentStateForm/>),
                ...tableViewRouter('instrument', <Instruments/>, <InstrumentForm/>),
                ...tableViewRouter('service_case', <ServiceCases/>, <ServiceCaseForm/>),
                ...tableViewRouter('btk', <BTKs/>, <BTKForm/>),
                ...tableViewRouter('loan', <Loans/>, <LoanForm/>),
                ...tableViewRouter('installation', <Installations/>, <InstallationForm/>),
                ...tableViewRouter('user', <Users/>, <UserForm/>),
                ...tableViewRouter('loan_state', <LoanStates/>, <LoanStateForm/>),
                ...tableViewRouter('loan_type', <LoanTypes/>, <LoanTypeForm/>),
                ...tableViewRouter('installation_state', <InstallationStates/>, <InstallationStateForm/>),
                ...tableViewRouter('service_case_state', <ServiceCaseStates/>, <ServiceCaseStateForm/>),
                ...tableViewRouter('service_case_action', <ServiceCaseActions/>, <ServiceCaseActionForm/>),
                ...tableViewRouter('service_case_type', <ServiceCaseTypes/>, <ServiceCaseTypeForm/>),
                ...tableViewRouter('service_case_regime_cost', <ServiceCaseRegimeCosts/>, <ServiceCaseRegimeCostForm/>),
                ...tableViewRouter('service_case_work', <ServiceCaseWorks/>, <ServiceCaseWorkForm/>),
                ...tableViewRouter('service_case_spare_part', <ServiceCaseSpareParts/>, <ServiceCaseSparePartForm/>),
                ...tableViewRouter('btk_state', <BTKStates/>, <BTKStateForm/>),
                ...tableViewRouter('btk_result', <BTKResults/>, <BTKResultForm/>),
                {
                    path: `/service_case_state_categories`,
                    element: <ServiceCaseStateCategories/>
                },
                {
                    path: `/service_case_state_categories/service_case_state_category/new`,
                    element: <ServiceCaseStateCategoryForm/>
                },
                {
                    path: `/service_case_state_categories/service_case_state_category/:id`,
                    element: <ServiceCaseStateCategoryForm/>
                },
                {
                    path: `/instruments_demo`,
                    element: <InstrumentsDemo/>
                },
                {
                    path: `/companies`,
                    element: <Companies/>
                },
                {
                    path: `/companies/company/new`,
                    element: <CompanyForm/>
                },
                {
                    path: `/companies/company/:id`,
                    element: <CompanyForm/>
                },
                {
                    path: `/companies/company/:companyName/address/new`,
                    element: <AddressForm/>
                },
                {
                    path: `/companies/company/:companyName/address/:id`,
                    element: <AddressForm/>
                },
                {
                    path: `/companies/company/:companyName/contact/new`,
                    element: <ContactForm/>
                },
                {
                    path: `/companies/company/:companyName/contact/:id`,
                    element: <ContactForm/>
                },
                {
                    path: `/company_setup/1`,
                    element: <CompanySetupForm/>
                },
                {
                    path: `/configuration`,
                    element: <ConfigurationSetupForm/>
                },
                {
                    path: `/pricelistLoader`,
                    element: <PricelistLoader/>
                },
                {
                    path: `/loan_instrument/:instrumentId`,
                    element: <LoanInstrumentHandler/>
                },
                {
                    path: `/qr`,
                    element: <QRScanner/>
                },
                {
                    path: `/qr/:id`,
                    element: <QRHandler/>
                },
                {
                    path: `/version_info`,
                    element: <VersionInfo/>
                }
            ]
        },
        {
            path: `/login`,
            element: <LoginWrapper/>
        }
    ]);
}

export default getRouter;
